import React from 'react';
const _str = {};
_str.POPUP_SEVERITY = {
  FAULT: 'fault',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
};
_str.POPUP_MESSAGES = {
  TITLES: {
    OOOPS: 'ooops...',
    HEY: 'Hey...',
    AWESOME: 'AWESOME!',
  },
  GENERIC_MESSAGES: {
    INFO_SAVED: 'Saved successfully!',
    ERROR_IN_SAVING:
      'Oh no... Something went wrong. Please try again or contact us at support@consolto.com',
  },
  CALL_APP_MESSAGES: {
    FREE_CALL_REQUEST: 'Incoming call ',
    JOIN_CALL_REQUEST: 'Join request',
    PAID_CALL_REQUEST: 'Please approve the call to receive a payment',
    PEER_PERFORMING_PAYMENT:
      'Your peer is finalizing the payment. You’ll be notified once it’s complete. Keep this window open',
    PEER_PAID:
      "Your peer has paid successfully and is waiting. Start the call when you're ready",
    PEER_HANGUP: 'Call Ended :)',
    PEER_DISCONNECT: 'Your peer has disconnected',
    PEER_CANCELED_PAYMENT:
      "We're sorry. It seems your customer has cancelled the payment during the process. ",
    MISSED_CALL: 'Missed call',
    PEER_CONNECTION_CLOSED_MESSAGE: 'Call Ended',
    SELF_CONNECTION_CLOSED: 'Call Ended',
    MENTOR_ACCEPTED_PAID_CALL: 'Your peer is ready. Please start payment',
    PAYPAL_ERROR:
      "We're sorry. There seems to be an issue with the payment. Please try later",
    CAMERA_ACCESS_PREVENTED:
      "We couldn't get access to the camera and/or microphone on this device. Please enable them first.",
    CAMERA_ACCESS_DIALOG_OPEN:
      'Please approve the camera and microphone in order to start a videocall.',
    VIDEO_NOT_SUPPORTED_ON_BROWSER: (
      <div>
        This browser doesn't support videocalls. <br />
        On iOS, Please move to Safari
      </div>
    ),
  },
  DAG_FLOW_MESSAGES: {
    PEER_REJECTED:
      "We're sorry. Your peer hasn't accepted the call. Please try again with another peer.",
  },
  CONTACT_US_MESSAGES: {
    REJECT:
      "We're sorry. \n Your mentor is probably busy or not available. \n Please try again in a few minutes.",
    SELF_CALL_MESSAGE: " We're sorry. \n You are trying to call yourself.",
    BUSY_MESSAGE: ' is busy or offline. \nCome back later! ',
    NEW_JOB_APPLICATIO_SUCCESS: 'We hear you... will get back to you soon',
    JOINING_TO_MAIL_LIST:
      "Thank you for joining our mailing list! We'll soon send you our first mail :)",
  },
  MENTOR_FRONT_PAGE_MESSAGES: {
    REJECTED_CALL_MESSAGE: 'Please try again later',
    SELF_CALL_MESSAGE: " We're sorry. \n You are trying to call yourself.",
    UNAVAILABLE_MESSAGE: 'Your peer is unavailable. Leave him a message',
    MESSAGE_TO_MENTOR_SUCCESS: 'Your message was sent :)',
    MESSAGE_TO_MENTOR_FAILURE:
      "There seems to be a problem and we couldn't deliver your message. Please try again later. ",
  },
  LOGIN_PAGE_MESSAGES: {
    FORGOT_PASSWORD_SUCCESS:
      'A link to reset your password was sent to the email you provided: ',
    FORGOT_PASSWORD_FAIL:
      'An error has occured while initializing your password. Make sure your email is: ',
    ERROR_EG_014:
      'You formerly signed up with a different method (google+ / facebook / email). Try to login with that exact method again',
    ERROR_EG_016:
      "Would you like to join us? Let's get you registered right away (we could not find your former registration)",
    ERROR_EG_021:
      "We've met (when you booked a meeting with us) :). Let's do it properly. Please register",
    ERROR_EG_027:
      "Sumo-ling, please use the same email you've used when activating on AppSumo :)",
    ERROR_EG_028:
      'Hey Sumo-ling, please register using your appsumo magic link (also been sent to your email)',
    ERROR_EG_001:
      'Hey, This user already exists and you may want to login or reset your password',
    ERROR_ER_020: "We're sorry. We couldn't retrive your email from Facebook",
    ERROR_ER_021: "Please register in order to enjoy Consolto's backoffice",
    ERROR_EG_007:
      'This reset-password link has expired. Please start the process again.',

    ERROR_GENERAL_ERROR:
      'Seems there was a problem with either your email or password. Please try again ',
    ENABLE_POPUP_MESSAGE:
      'Please enable popups in order to login with facebook/google ',
  },
  REGISTRATION_PAGE_MESSAGES: {
    CREATION_FAILURE_CALLBACK_MESSAGE:
      'Your request for registration was successfully received. \n We have saved your details and will contact after review\n' +
      ' Thank you for your interest!',
    TERMS_NOT_ACCEPTED_MESSAGE: "Please ensure you've accepted the terms.",
  },
  MENTOR_SESSION_PAGE_MESSAGES: {
    REGISTRATION_SUCCESS_MESSAGE:
      "Registration success!! You're one of us now :) ",
    GET_SESSION_TEMPLATES_FAIL: 'Something got wrong ',
    GET_SESSION_TEMPLATE_MAX_SESSIONS:
      'You reached the maximum number of sessions.\n This session will not be added. ',
    DELETE_SESSION_SECCUSS_MESSAGE:
      'The session was deleted successfully.\n Close this window to continue. ',
    DEFAULT_SESSION_SETTING_FAIL:
      'Something in the deleting process went wrong. ',
    SESSION_DELETE_FAIL:
      'Hey, we cannot delete the last session. Instead of deleting it, just edit it :) ',
  },
  MENTOR_PROFILE_PAGE_MESSAGES: {
    SAVE_MENTOR_SUCCESS: 'The information was saved!',
  },
  SESSION_DIRECTIVE_MESSAGES: {
    SAVE_ERROR_GENERAL_MESSAGE:
      "The data couldn't be saved. \n Please check your internet connectivity. ",
    SAVE_ERROR_SESSION_DURATION_MESSAGE:
      'Please fix the session duration. It should be a multiplication of 15 minutes. ',
    SAVE_ERROR_SESSION_COST_MESSAGE:
      'Please fix the session cost. It should be an integer. ',
    SAVE_SECCUESS_MESSAGE: 'The data was saved successfuly.\n',
    SAVE_DEFAULT_ERROR_MESSAGE:
      "The default status of this session couldn't be updated.\n Please check your internet connectivity. ",
    SAVE_DEFAULT_SECCUUSS_MESSAGE:
      'The default status of this session was updated successfully.\nPlease close this window to continue. ',
    DELETE_SESSION_FAIL_MESSAGE:
      "The session couldn't be deleted.Please check your internet connectivity. ",
    CHANGE_PICTURE_ERROR_MESSAGE:
      "The picture couldn't be saved.Please check your internet connectivity. ",
    CHANGE_PICTURE_SUCCESS_MESSAGE:
      'The picture was saved successfully.Close this window to continue. ',
  },
  DOWNLOAD_THE_WIDGET_MESSAGES: {
    PAYMENT_FAIL_MESSAGE:
      "    There seemed to be a problem with the payment process. We'd love to provide you a great experience so go on and continue the installation process and we'll contact you later. ",
    SESSION_TIMELIMIT_MESSAGE:
      "Minimum session time is 15 minutes. Think about it - intro and hello's alone take a few minutes. ",
  },
  BOOKING_FLOW_MESSAGES: {
    EMAIL_ENTERING_FAIL_MESSAGE:
      'Sorry but you are already register, please log in and try again',
  },
  MAP_MESSAGES: {
    DELETE_SUB_TRIP:
      'Are you sure you want to delete all the points in that day/sub-trip? ',
    CANNOT_REMOVE_LAST_SUBTRIP: 'Hey, at least one daily trip is required',
  },
  ACCOUNT_PAGE_MESSAGES: {
    ACCOUNT_USER_CREATED_SUCCESSFULLY: 'Account user created successfully',
    ACCOUNT_CREATED_SUCCESSFULLY: 'Account created successfully',
    USER_ADDED_SUCCESSFULLY: 'User added successfully',
    ACCOUNT_UPDATED_SUCCESSFULLY: 'Saved successfully :)',
    NOT_ACCOUNT_MANAGER:
      'Editing the account is accessible to account managers only',
    ACCOUNT_USER_REMOVED_SUCCESSFULLY:
      'The user was successfully removed from your account',
    SURE_TO_REMOVE_USER:
      'Are you sure you want to remove this user from your team-account? You will be able to add them back only by contacting the Consolto support team. ',
  },
  BILLING_MESSAGES: {
    PAYMENT_CANCELLED:
      "We're sorry you cancelled the payment. Let us know how we can make this right for you",
    PAYMENT_ERROR:
      "We're sorry, there seems to be an error somewhere around the internet :) Please contact us right away",
    ARE_YOU_SURE:
      'Are you absolutely sure you want to cancel your subscription?',
    THANK_YOU: (
      <div>
        <div>THANK YOU! </div>
        <div>Your plan has been activated </div>
      </div>
    ),
    PLAN_CANCELLED:
      'We’re sorry to see you go. Your account has been cancelled. ',
  },
  BILLING_ENFORCER_MESSAGES: {
    TRIAL_END_4_DAYS: (
      <div>
        We're glad you're enjoying Consolto. <br /> Your trial ends in 4 days.
        <br /> Would you like to set a plan?
      </div>
    ),
    TRIAL_END_3_DAYS:
      "We're glad you're enjoying Consolto. Your trial ends in 3 days. Would you like to set a plan?",
    TRIAL_END_2_DAYS:
      "We're glad you're enjoying Consolto. Your trial ends in 2 days. Would you like to set a plan?",
    TRIAL_END_1_DAYS:
      "We're glad you're enjoying Consolto. Your trial ends tomorrow. Would you like to set a plan?",
    TRIAL_END_TODAY:
      "We're glad you're enjoying Consolto. Your trial ends today. Let's pick a plan. ",
    TRIAL_COMPLETED: `Free trial complete.`,
    TRIAL_COMPLETED_INFO_TEXT: `Time to unlock the full power of productivity`,
    BLACK_FRIDAY: `We're glad you're enjoying Consolto. Let's pick a plan`,
  },
  PERSONAL_SETTINGS_PAGE: {
    EMAIL_CHANGED_SUCCESSFULLY:
      "Email changed successfully :) Let's reload your page",
    PASSWORD_CHANGED_SUCCESSFULLY:
      "Password changed successfully :) Let's reload your page",
  },
  SMTP_INTEGRATION: {
    ARE_YOU_SURE: 'Are you sure you want to delete your smtp configuration?',
  },
};
_str.ERROR_MESSAGES = {
  REGISTRATION_PAGE_MESSAGES: {
    MISSING_NAME: `We'd really like to get to know you... (more than 2 characters
      please :))`,
    WRONG_EMAIL: "That doesn't look like an email to me... ",
    WRONG_PASSWORD:
      "We're pretty flexible... but want you to be safe and secure. 8+ characters ",
  },
  PERSONAL_SETTINGS_PAGE: {
    'EG-005':
      "We're pretty flexible... but want you to be safe and secure. Please enter your password",
    'EG-001': 'This email already exists in our records',
    'EG-020':
      'This email was registered via facebook/google. Please contact our support to change it',
    'EG-003': "This is wierd.. we couldn't find this user",
    'ER-001': 'Please enter a valid password',
    'ER-013': 'Password length should be minimum of 6 characters',
  },
  WIDGET_APIS: {
    'EG-029':
      "You've exceeded the amount of agent skins permitted in this account. Please change the purchased plan.",
  },
  ACCOUNT_SETTINGS_PAGE: {
    'EG-001':
      'This user is already part of the Consolto family. To add to your account, please send an email to info@consolto.com',
    'AGE-003': 'You are not authorized to perform this action',
    'AGE-004':
      'This user is already part of the Consolto family. Please send an email to info@consolto.com',
    'AGE-005': "You've tried to delete a user that does not exist",
    'AGE-007':
      'Hey, we need you here :) You cannot delete yourself from the account',
    'AGE-008':
      "He, we need someone to manage things here... we can't delete the last account manager from the account.",
    'ACR-001': "We need the user's first name and last name...",
    'ACR-002': 'Please enter a valid password with at least 6 characters',
    'ACR-003':
      'Please enter a valid email to invite the user to join your account',
    'ACR-004': 'Please enter a valid password with 6 digits',
    'ACR-005': 'Please enter a valid password with 6 digits',
    'ACR-006': 'The number of Widgets should be non-negative',
    'ACR-007': 'The number of Widgets should be less than or equal 20',
    'ACR-008': 'The priority number must be greater than -1',
    'ACR-009': 'The priority number must be less than or equal 100',
    'ACR-010': "We'd need a userId to accomplish that",
    'ACR-011':
      "We're missing some data. Please contact us at support@consolto.com",
    'ACR-012':
      "We're missing some data. Please contact us at support@consolto.com",
    'AGE-009':
      "You've reached your account limit. Would you like to increase the amount of seats?",
  },
  PAYMENTS: {
    'P-001': 'Paypal key does not match with money transaction key',
  },
  SCHEDULING: {
    'AE-006': 'Please provide all the required information',
    'BFE-009':
      'The selected time is not available. Please select another time slot.',
    'BFE-010':
      'The selected time is not available. Please select another time slot.',
    'ER-002': 'Please provide a valid email',
  },
};

_str.NOTIFICATIONS = {
  TITLES: {
    MESSAGE_ARRIVED: 'Consolto: message arrived',
    APPOINTMENT_REMINDER: 'Consolto: Appointment reminder',
    MEETING_ROOM: 'Consolto: Meeting started',
  },
  MESSAGES: {
    APPOINTMENT_REQUEST_ARRIVED: 'New appointment request arrived',
    TEXT_MESSAGE_ARRIVED: 'New text message arrived',
    CALL_REQUEST_ARRIVED: 'You have a call',
    MEETING_ROOM_PEER_JOINED: 'A guest has joined the call',
  },
};

export default _str;
